<template>
    <BTable :items="files"  :fields="fields" striped show-empty >
        <template  v-slot:cell(name)="data">
            <a href="#" @click="getFile(data.item)">
                {{data.item.name}}
            </a>
        </template>
    </BTable>
</template>

<script>

import {
    BOverlay,
    BTable,
} from 'bootstrap-vue-next';
export default {
    name: "tender_files",
    props : {
        tender: {
            type: Object,
            required: true
        }
    },
    components : {
        BTable,
    },
    data() {
        return {
            is_load : false,
            files : [],
            fields : [
                { key: 'id', label: 'ID' },
                { key: 'name', label: 'Назва Файлу'  },
            ],
        }
    },
    
    created() {
        this.loadFiles();
    },
    
    methods : {
        onRowClicked(row) {
        
        },
        
        getFile(file) {
            console.log(file);
            window.location.href = '/internal/media/file/' + file.file_id;
        },
        
        async loadFiles() {
            this.is_load = true;
            this.files = [];
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/files").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.files = data.data;
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
    
}
</script>

<style scoped>

</style>